const pageNameKey = "buttonWithIcon";

export const buttonWithIconEn = {
  [pageNameKey]: {
    buttonWithIconAltText: "Button with icon",
  },
};

export const buttonWithIconPtBr = {
  [pageNameKey]: {
    buttonWithIconAltText: "Botão com ícone",
  },
};

export const buttonWithIconDe = {
  [pageNameKey]: {
    buttonWithIconAltText: "Button mit Symbol",
  },
};

export const buttonWithIconZhHans = {
  [pageNameKey]: {
    buttonWithIconAltText: "带图标的按钮",
  },
};

export const buttonWithIconIt = {
  [pageNameKey]: {
    buttonWithIconAltText: "Pulsante con icona",
  },
};

export const buttonWithIconEs = {
  [pageNameKey]: {
    buttonWithIconAltText: "Botón con icono",
  },
};

export const buttonWithIconNl = {
  [pageNameKey]: {
    buttonWithIconAltText: "Knop met pictogram",
  },
};

export const buttonWithIconTr = {
  [pageNameKey]: {
    buttonWithIconAltText: "Simgeli düğme",
  },
};
